export const eventServices = [
  { icon: "ri-building-line", title: "Eventos Corporativos", description: "Coffee breaks e lanches para reunioes e eventos empresariais." },
  { icon: "ri-briefcase-line", title: "Reuniões Empresariais", description: "Alimentação prática e elegante para suas reuniões de negócios." },
  { icon: "ri-presentation-line", title: "Treinamentos", description: "Cardápios que mantêm a energia alta durante todo o treinamento." },
  { icon: "ri-global-line", title: "Congressos", description: "Soluções em escala para congressos e grandes convenções." },
  { icon: "ri-computer-line", title: "Workshops", description: "Lanches leves e nutritivos para workshops e sessões práticas." },
  { icon: "ri-school-line", title: "Escolas", description: "Alimentação saudável e segura para o refeitório escolar." },
  { icon: "ri-graduation-cap-line", title: "Universidades", description: "Fornecimento para cantinas universitarias e eventos academicos." },
  { icon: "ri-goblet-line", title: "Confraternizações", description: "Cardápios festivos para celebrações e eventos de integração." },
  { icon: "ri-football-line", title: "Eventos Esportivos", description: "Refeições práticas e nutritivas para atletas e torcedores." },
  { icon: "ri-government-line", title: "Eventos Institucionais", description: "Alimentacao organizada para eventos publicos e institucionais." },
];

export const eventDifferentials = [
  "Cardápios personalizados",
  "Produção própria",
  "Ingredientes frescos",
  "Seguranca alimentar",
  "Entrega pontual",
  "Excelente apresentação",
  "Atendimento personalizado",
  "Flexibilidade de quantidades",
  "Atendimento para pequenos e grandes eventos",
];